import React, { useEffect, useState } from "react";
import PhoneCallApplicantPopup from "./PhoneCallApplicantPopup";
import Moment from "react-moment";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  addAppPhoneCall, deleteAppPhoneCall, getAppPhoneCalls,
  getAppPhoneCallsAddedStatus, getAppPhoneCallsDeletedStatus,
  getAppPhoneCallsUpdatedStatus, loadAppPhoneCalls, updateAppPhoneCall,
  getAppPhoneCallsLoading, getAppPhoneCallsDeleteLoading
} from "../../app/store/phoneCall";
import { getCurrentUser } from "../../app/store/auth";
import { getAlert, getConfirmAlert } from "../../services/appAlerts";
import NotesPopover from "../../comman/NotesPopover";

const PhoneCallApplicant = (props) => {
  const { workflowTask, handleUpdateComponent } = props;
  const [appPhoneCalls, setAppPhoneCalls] = useState([]);
  const [selectedPhoneCallId, setSelectedPhoneCallId] = useState(0);
  const [selectedPhoneCall, setSelectedPhoneCall] = useState(null);
  const [selectedKey, setSelectedKey] = useState("home");
  const [updateCompStatus, setUpdateCompStatus] = useState(false);
  const [deletingPhoneId, setDeletingPhoneId] = useState(null);

  const appPhoneCallsSelector = useSelector(getAppPhoneCalls);
  const appPhoneCallsAddedStatusSelector = useSelector(getAppPhoneCallsAddedStatus);
  const appPhoneCallsDeletedStatusSelector = useSelector(getAppPhoneCallsDeletedStatus);
  const appPhoneCallsUpdatedStatusSelector = useSelector(getAppPhoneCallsUpdatedStatus);
  const isLoading = useSelector(getAppPhoneCallsLoading);
  const isDeleteLoading = useSelector(getAppPhoneCallsDeleteLoading);

  const dispatch = useDispatch();
  const currentUser = getCurrentUser()

  useEffect(() => {
    if (workflowTask?.ciid) {
      dispatch(loadAppPhoneCalls(workflowTask.ciid))
      setUpdateCompStatus(true);
    }

  }, []);

  useEffect(() => {
    if (appPhoneCallsSelector.length > 0) {
      setAppPhoneCalls(appPhoneCallsSelector)
      let callItems = "";
      appPhoneCallsSelector.map((x, key) => {
        if (key > 0) callItems += ",";
        callItems += x.phoneId;
      })
      if (updateCompStatus) {
        handleUpdateComponent(callItems);
        setUpdateCompStatus(false);
      }
    } else {
      setAppPhoneCalls([]);
    }

  }, [appPhoneCallsSelector]);

  const handleSubmit = async (data) => {
    const phoneCell = {
      callDate: data["callDate"],
      callTime: data["callTime"],
      comments: data["comments"],
      duration: data["duration"],
      wiid: workflowTask.wiid,
      ciid: workflowTask.ciid,
      performerId: currentUser.id,
    };
    dispatch(addAppPhoneCall(phoneCell));
  };

  useEffect(() => {
    if (appPhoneCallsAddedStatusSelector && workflowTask?.ciid) {
      getAlert("", "Added Successfully", "success");
      dispatch(loadAppPhoneCalls(workflowTask.ciid));
      setUpdateCompStatus(true);
      setSelectedKey("home");
      setSelectedPhoneCallId(0);
    }
  }, [appPhoneCallsAddedStatusSelector]);

  useEffect(() => {
    if (appPhoneCallsUpdatedStatusSelector && workflowTask?.ciid) {
      getAlert("", "Updated Successfully", "success");
      dispatch(loadAppPhoneCalls(workflowTask.ciid));
      setSelectedKey("home");
      setSelectedPhoneCallId(0);
    }
  }, [appPhoneCallsUpdatedStatusSelector]);

  useEffect(() => {
    if (appPhoneCallsDeletedStatusSelector && workflowTask?.ciid) {
      setDeletingPhoneId(null);
      getAlert("", "Deleted Successfully", "success");
      dispatch(loadAppPhoneCalls(workflowTask.ciid));
      setUpdateCompStatus(true);
      handleResetSelection();
    }
  }, [appPhoneCallsDeletedStatusSelector])


  const handleEditComment = (item) => {
    dispatch(updateAppPhoneCall(item));
  };

  const handleDeleteComment = async (item) => {
    const result = await getConfirmAlert("Warning", "Are you sure, you want to Delete this Phone Call Notes", "warning");
    if (result.isConfirmed) {
      setDeletingPhoneId(item.phoneId);
      dispatch(deleteAppPhoneCall(item));
    }
  };

  const handleSelectTab = (tab) => {
    setSelectedKey(tab);
  }

  const handleResetSelection = () => {
    setSelectedPhoneCallId(0);
    setSelectedPhoneCall(null);
  }

  const handleSelectPhoneCall = (phone) => {
    if (selectedPhoneCallId === phone.phoneId) {
      handleResetSelection();
    } else {
      setSelectedPhoneCall(phone);
      setSelectedPhoneCallId(phone.phoneId);
    }
  }

  const renderSelectedCallCard = () => {
    if (selectedPhoneCallId === 0 || !selectedPhoneCall) return null;

    return (
      <div className="rt-msg-selected-card">
        <div className="rt-msg-selected-info">
          <div className="rt-msg-selected-avatar">
            <i className="fa fa-phone" aria-hidden="true" style={{ fontSize: "20px" }} />
          </div>
          <div className="rt-msg-selected-meta">
            <strong>
              <Moment format="MMM D, YYYY">{selectedPhoneCall.callDate}</Moment>
              {" at "}
              {moment(selectedPhoneCall.callTime?.replace(":00", ""), "hhmm").format("h:mm a")}
            </strong>
            <span>
              <i className="fa fa-hourglass-half" aria-hidden="true" />
              {selectedPhoneCall.duration} Min
              <span>&bull;</span>
              <span className="rt-form-status-tag is-updated">Logged</span>
            </span>
          </div>
        </div>
        <div className="rt-msg-selected-actions">
          <button
            className="rt-form-action-btn is-view"
            onClick={() => handleSelectTab("profile")}
            type="button"
          >
            <i className="fa fa-pencil" aria-hidden="true" /> Edit
          </button>
          <button
            className="rt-form-action-btn is-delete"
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteComment(selectedPhoneCall);
            }}
            type="button"
            title="Delete Call Log"
            disabled={isDeleteLoading && deletingPhoneId === selectedPhoneCall.phoneId}
          >
            {isDeleteLoading && deletingPhoneId === selectedPhoneCall.phoneId ? (
              <><i className="fa fa-spinner fa-spin" aria-hidden="true" /> Deleting...</>
            ) : (
              <><i className="fa fa-trash-o" aria-hidden="true" /> Delete</>
            )}
          </button>
          <button
            className="rt-form-action-btn is-clear"
            onClick={handleResetSelection}
            type="button"
            title="Clear selection"
          >
            <i className="fa fa-times" aria-hidden="true" />
          </button>
        </div>
      </div>
    );
  };

  const skeletonWidths = ["sk-medium", "sk-short", "sk-short", "sk-long", "sk-medium", "sk-short"];

  return (
    <React.Fragment>
      <div className="rt-form-workbench">
        <style>{`
          :root {
            --primary-color: #2563eb;
            --primary-hover: #1d4ed8;
            --primary-soft: #eff6ff;
            --secondary-color: #64748b;
            --secondary-hover: #475569;
            --border-color: #e2e8f0;
            --bg-light: #f8fafc;
            --text-main: #1e293b;
            --text-muted: #64748b;
          }

          .rt-form-workbench {
            font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
            background: transparent !important;
            color: #1e293b !important;
            --task-accent: #2563eb !important;
            --task-soft: #eff6ff !important;
            position: relative;
          }

          @keyframes loadingBar {
            0%   { width: 0%; opacity: 1; }
            70%  { width: 85%; opacity: 1; }
            100% { width: 100%; opacity: 0; }
          }

          .wf-loading-bar {
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            right: 0 !important;
            height: 3px !important;
            background: linear-gradient(90deg, #2563eb, #7c3aed, #2563eb) !important;
            background-size: 200% 100% !important;
            animation: loadingBar 1.6s ease-in-out infinite !important;
            z-index: 10 !important;
          }

          @keyframes shimmer {
            0%   { background-position: -600px 0; }
            100% { background-position: 600px 0; }
          }

          .skeleton-cell {
            display: block;
            height: 13px;
            border-radius: 6px;
            background: linear-gradient(
              90deg,
              #f1f5f9 25%,
              #e2e8f0 50%,
              #f1f5f9 75%
            );
            background-size: 600px 100%;
            animation: shimmer 1.4s ease-in-out infinite;
          }

          .skeleton-cell.sk-short  { width: 40%; }
          .skeleton-cell.sk-medium { width: 65%; }
          .skeleton-cell.sk-long   { width: 85%; }
          .skeleton-cell.sk-full   { width: 92%; }

          .skeleton-row td {
            padding: 14px 16px !important;
          }

          .rt-msg-tab-bar {
            display: flex;
            align-items: stretch;
            gap: 4px;
            border-bottom: 2px solid #f1f5f9;
            margin-bottom: 12px !important;
            padding: 8px 4px 0;
            position: relative;
          }

          .rt-msg-tab-btn {
            position: relative;
            display: inline-flex;
            align-items: center;
            gap: 7px;
            border: none;
            background: transparent;
            padding: 9px 16px 11px;
            font-size: 14px;
            font-weight: 500;
            color: #64748b;
            cursor: pointer;
            border-radius: 8px 8px 0 0;
            transition: color 0.2s ease, background 0.2s ease;
            outline: none;
            white-space: nowrap;
          }
          .rt-msg-tab-btn i {
            font-size: 13px;
            transition: color 0.2s ease;
          }
          .rt-msg-tab-btn:hover {
            color: #1e293b;
            background: rgba(37,99,235,0.04);
          }
          .rt-msg-tab-btn:focus,
          .rt-msg-tab-btn:focus-visible,
          .rt-msg-tab-btn:active {
            outline: none !important;
            box-shadow: none !important;
            border-color: transparent !important;
          }
          .rt-msg-tab-btn.active {
            color: var(--task-accent, #2563eb);
            font-weight: 500;
          }
          .rt-msg-tab-btn.active i {
            color: var(--task-accent, #2563eb);
          }
          .rt-msg-tab-btn::after {
            content: "";
            position: absolute;
            bottom: -2px;
            left: 0;
            right: 0;
            height: 2px;
            background: var(--task-accent, #2563eb);
            border-radius: 2px 2px 0 0;
            transform: scaleX(0);
            transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .rt-msg-tab-btn.active::after {
            transform: scaleX(1);
          }
          .rt-msg-tab-badge {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 20px;
            height: 20px;
            padding: 0 6px;
            border-radius: 999px;
            font-size: 12px;
            font-weight: 600;
            background: #f1f5f9;
            color: #64748b;
            border: 1px solid #e2e8f0;
            line-height: 1;
            transition: all 0.2s ease;
          }
          .rt-msg-tab-btn.active .rt-msg-tab-badge {
            background: var(--task-soft, rgba(37,99,235,0.1));
            color: var(--task-accent, #1d4ed8);
            border-color: var(--task-accent, rgba(37,99,235,0.2));
          }

          .rt-msg-panel {
            animation: rtMsgTabFadeIn 0.28s cubic-bezier(0.16, 1, 0.3, 1) both !important;
            flex: 1 1 auto !important;
            min-height: auto !important;
            overflow-y: visible !important;
            overflow-x: hidden !important;
            padding-top: 4px !important;
            padding-right: 4px !important;
          }
          .rt-msg-panel.is-form-panel {
            padding-top: 4px !important;
          }
          @keyframes rtMsgTabFadeIn {
            from { opacity: 0; transform: translateY(6px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .rt-msg-selected-card {
            display: flex !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 20px !important;
            padding: 18px 22px !important;
            margin: 0 0 12px 0 !important;
            border: 1px solid rgba(37,99,235,0.12) !important;
            border-radius: 14px !important;
            background: linear-gradient(135deg, rgba(37,99,235,0.04) 0%, rgba(124,58,237,0.03) 100%) !important;
            flex-wrap: wrap !important;
            animation: rtMsgTabFadeIn 0.3s ease both !important;
          }
          .rt-msg-selected-info {
            display: flex !important;
            align-items: center !important;
            gap: 14px !important;
            min-width: 0 !important;
          }
          .rt-msg-selected-avatar {
            width: 46px !important;
            height: 46px !important;
            border-radius: 12px !important;
            background: linear-gradient(135deg, #2563eb, #7c3aed) !important;
            color: #ffffff !important;
            display: flex !important;
            align-items: center !important;
            justify-content: center !important;
            font-size: 18px !important;
            font-weight: 500 !important;
            flex-shrink: 0 !important;
            box-shadow: 0 4px 10px rgba(37,99,235,0.2) !important;
            border: 2px solid #ffffff !important;
          }
          .rt-msg-selected-meta {
            display: flex !important;
            flex-direction: column !important;
            gap: 4px !important;
            min-width: 0 !important;
          }
          .rt-msg-selected-meta strong {
            display: block !important;
            color: #1e293b !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            margin-bottom: 3px !important;
          }
          .rt-msg-selected-meta span {
            color: #64748b !important;
            font-size: 14px !important;
            font-weight: 400 !important;
            display: flex !important;
            align-items: center !important;
            gap: 7px !important;
            flex-wrap: wrap !important;
          }
          .rt-msg-selected-actions {
            display: flex !important;
            align-items: center !important;
            gap: 8px !important;
            flex-wrap: wrap !important;
            flex-shrink: 0 !important;
          }
          .rt-msg-selected-actions .rt-form-action-btn {
            height: 38px !important;
            box-sizing: border-box !important;
            justify-content: center !important;
          }
          .rt-msg-selected-actions .rt-form-action-btn.is-clear {
            min-width: auto !important;
            width: 38px !important;
            padding: 0 !important;
          }

          .rt-msg-table-scroll {
            overflow: auto !important;
            max-height: 460px !important;
            border-radius: 0.375rem !important;
            position: relative !important;
            scrollbar-width: thin !important;
            scrollbar-color: #94a3b8 #f1f5f9 !important;
          }
          .rt-msg-table {
            width: 100%;
            margin-bottom: 0;
            margin-top: 0px !important;
            border: none;
            border-collapse: separate;
            border-spacing: 0;
            color: var(--text-main, #1e293b);
          }
          .rt-msg-table thead {
            position: sticky;
            top: 0;
            z-index: 2;
            background: var(--bg-light, #f8fafc);
          }
          .rt-msg-table thead tr th:first-child {
            border-top-left-radius: 0.375rem !important;
          }
          .rt-msg-table thead tr th:last-child {
            border-top-right-radius: 0.375rem !important;
          }
          .rt-msg-table thead th {
            color: var(--text-muted, #64748b);
            font-size: 12px;
            font-weight: 600;
            letter-spacing: 0.05em;
            text-transform: uppercase;
            padding: 12px 16px;
            border-top: none;
            border-bottom: 1px solid var(--border-color, #e2e8f0);
            white-space: nowrap;
          }
          .rt-form-workbench .rt-msg-table td {
            padding: 14px 16px;
            font-size: 14px;
            font-weight: 400;
            color: var(--text-main, #1e293b);
            vertical-align: middle;
            border-top: none;
            border-bottom: 1px solid var(--border-color, #e2e8f0);
            background: transparent !important;
            background-color: transparent !important;
            transition: all 0.15s ease;
          }
          .rt-form-workbench .rt-msg-table tbody tr:last-child td {
            border-bottom: none;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row {
            cursor: pointer;
            transition: transform 0.1s ease !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row:active {
            transform: scaleY(0.98) !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row:hover td {
            background-color: rgba(37, 99, 235, 0.04) !important;
            color: #1e293b !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row:hover td:first-child {
            box-shadow: inset 3px 0 0 0 rgba(37, 99, 235, 0.35) !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td {
            background-color: rgba(37, 99, 235, 0.07) !important;
            color: #1e3a8a !important;
            font-weight: 500 !important;
            border-bottom: 1px solid rgba(37, 99, 235, 0.08) !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row td:first-child {
            box-shadow: inset 4px 0 0 0 #2563eb !important;
          }
          .rt-form-workbench .rt-msg-table tbody tr.rt-msg-row.selected-row:hover td {
            background-color: rgba(37, 99, 235, 0.09) !important;
          }

          .rt-msg-time {
            display: flex !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 2px !important;
          }
          .rt-msg-time-row {
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
          }
          .rt-msg-time-date {
            font-weight: 400 !important;
            color: #1e293b !important;
          }
          .rt-msg-time-subtext {
            font-size: 14px !important;
            font-weight: 400 !important;
            color: var(--text-muted, #64748b) !important;
            padding-left: 30px !important;
          }
          .rt-msg-time-icon {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            border-radius: 6px;
            background: var(--bg-light, #f8fafc);
            color: var(--text-muted, #64748b);
            font-size: 12px;
          }
          .rt-msg-empty-state {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 220px;
            padding: 36px 20px;
            text-align: center;
            background: #ffffff;
            border-radius: 12px;
          }
          .rt-msg-empty-icon {
            width: 48px;
            height: 48px;
            border-radius: 12px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            background: var(--primary-soft, #eff6ff);
            color: var(--primary-color, #2563eb);
            font-size: 20px;
            margin-bottom: 16px;
          }
          .rt-msg-empty-title { margin: 0; color: var(--text-main, #1e293b); font-size: 14px; font-weight: 500; }
          .rt-msg-empty-desc { margin: 6px 0 0; color: var(--text-muted, #64748b); font-size: 14px; font-weight: 400; }

          .wf-name-cell {
            display: flex !important;
            align-items: center !important;
            gap: 10px !important;
            min-width: 190px !important;
          }
          .wf-name-avatar {
            width: 34px !important;
            height: 34px !important;
            border-radius: 10px !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            background: linear-gradient(135deg, rgba(37,99,235,0.12), rgba(20,184,166,0.1)) !important;
            border: 1px solid rgba(37,99,235,0.16) !important;
            color: #1d4ed8 !important;
            font-size: 12px !important;
            font-weight: 500 !important;
            flex-shrink: 0 !important;
          }
          .wf-name-meta {
            display: flex !important;
            flex-direction: column !important;
            gap: 2px !important;
            min-width: 0 !important;
          }
          .wf-name-main {
            font-weight: 400 !important;
            color: #1e293b !important;
            font-size: 14px !important;
            line-height: 1.2 !important;
          }
          .wf-name-title {
            font-size: 14px !important;
            color: #64748b !important;
            font-weight: 400 !important;
            line-height: 1.2 !important;
          }
          .wf-empty-value {
            color: #64748b !important;
            font-size: 14px !important;
            font-weight: 400 !important;
          }

          .rt-form-status-tag {
            font-size: 12px !important;
            font-weight: 600 !important;
            text-transform: uppercase !important;
            padding: 2px 6px !important;
            border-radius: 4px !important;
            letter-spacing: 0.02em !important;
            display: inline-block !important;
          }
          .rt-form-status-tag.is-updated {
            background: #ecfdf5 !important;
            color: #065f46 !important;
            border: 1px solid #a7f3d0 !important;
          }

          .rt-form-action-btn {
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            gap: 6px !important;
            padding: 7px 14px !important;
            border-radius: 0 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            cursor: pointer !important;
            border: 1px solid #cbd5e1 !important;
            background: #ffffff !important;
            color: #1e293b !important;
            box-shadow: 0 2px 5px rgba(15,23,42,0.08) !important;
            outline: none !important;
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
            white-space: nowrap !important;
            min-width: 80px !important;
            font-family: inherit !important;
          }
          .rt-form-action-btn:hover {
            background: #f8fafc !important;
            color: #1e293b !important;
            border-color: #94a3b8 !important;
            transform: translateY(-1.5px) !important;
            box-shadow: 0 2px 5px rgba(15,23,42,0.08) !important;
          }
          .rt-form-action-btn.is-delete {
            border-color: #ef4444 !important;
            color: #ef4444 !important;
            min-width: auto !important;
          }
          .rt-form-action-btn.is-delete:hover {
            background: #ef4444 !important;
            color: #ffffff !important;
            border-color: #ef4444 !important;
            box-shadow: 0 4px 10px -1px rgba(239, 68, 68, 0.25) !important;
          }
          .rt-form-action-btn.is-view {
            border-color: var(--task-accent, #3b82f6) !important;
            color: var(--task-accent, #3b82f6) !important;
          }
          .rt-form-action-btn.is-view:hover {
            background: var(--task-accent, #3b82f6) !important;
            color: #ffffff !important;
            border-color: var(--task-accent, #3b82f6) !important;
            box-shadow: 0 4px 10px -1px rgba(59, 130, 246, 0.25) !important;
          }
          .rt-form-action-btn:disabled {
            opacity: 0.65 !important;
            cursor: not-allowed !important;
            pointer-events: none !important;
            transform: none !important;
            box-shadow: none !important;
          }
          .rt-form-action-btn.is-notes-btn {
            min-width: auto !important;
            padding: 7px 14px !important;
            font-size: 14px !important;
          }
          /* NotesPopover styles are now in ../../comman/NotesPopover.jsx */
          .rt-form-buttons-row .rt-form-action-btn.is-delete {
            height: 32px !important;
            min-width: auto !important;
            width: 32px !important;
            padding: 0 !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
          }

          .rt-call-duration-tag {
            font-size: 12px !important;
            font-weight: 600 !important;
            text-transform: uppercase !important;
            background: #f0fdf4 !important;
            color: #166534 !important;
            border: 1px solid #bbf7d0 !important;
            padding: 2px 6px !important;
            border-radius: 4px !important;
            letter-spacing: 0.02em !important;
            display: inline-flex !important;
            align-items: center !important;
            gap: 3px !important;
          }
        `}</style>

        {/* ─── Tab Bar ─── */}
        <div className="rt-msg-tab-bar">
          <button
            type="button"
            className={`rt-msg-tab-btn ${selectedKey === "home" ? "active" : ""}`}
            onClick={() => handleSelectTab("home")}
          >
            <i className="fa fa-phone" />
            Phone Call Notes
            <span className="rt-msg-tab-badge">{appPhoneCalls.length}</span>
          </button>
          <button
            type="button"
            className={`rt-msg-tab-btn ${selectedKey === "profile" ? "active" : ""}`}
            onClick={() => handleSelectTab("profile")}
          >
            <i className={`fa ${selectedPhoneCallId > 0 ? "fa-pencil" : "fa-plus"}`} />
            {selectedPhoneCallId > 0 ? "Edit Note" : "Add Note"}
          </button>
        </div>

        {/* ─── Home Tab ─── */}
        {selectedKey === "home" && (
          <div className="rt-msg-panel">
            {renderSelectedCallCard()}

            {!isLoading && appPhoneCalls.length === 0 ? (
              <div className="rt-msg-empty-state">
                <div className="rt-msg-empty-icon"><i className="fa fa-phone" /></div>
                <p className="rt-msg-empty-title">No Phone Call Notes</p>
                <p className="rt-msg-empty-desc">Click "Add Note" to log a phone call with the applicant.</p>
              </div>
            ) : (
              <div className="table-responsive rt-msg-table-scroll">
                <table className="table align-items-center table-flush rt-msg-table">
                  <thead>
                    {isLoading && (
                      <tr style={{ height: "0px", padding: 0 }}>
                        <th colSpan={5} style={{ padding: 0, border: "none", height: "0px", position: "relative" }}>
                          <div className="wf-loading-bar" />
                        </th>
                      </tr>
                    )}
                    <tr>
                      <th>#</th>
                      <th>Date & Time</th>
                      <th>Duration</th>
                      <th>Notes</th>
                      <th>Logged By</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      [...Array(4)].map((_, i) => (
                        <tr key={`sk-${i}`} className="skeleton-row">
                          {skeletonWidths.map((w, j) => (
                            <td key={j}><span className={`skeleton-cell ${w}`} /></td>
                          ))}
                        </tr>
                      ))
                    ) : (
                      appPhoneCalls.map((item, key) => {
                        const isSelected = selectedPhoneCallId === item.phoneId;
                        const canDelete = workflowTask.wiid === item.wiid;

                        return (
                          <tr
                            key={item.phoneId}
                            className={`rt-msg-row ${isSelected ? "selected-row" : ""}`}
                            onClick={() => handleSelectPhoneCall(item)}
                          >
                            <td style={{ width: "40px", fontWeight: 400, color: "#94a3b8" }}>
                              {key + 1}
                            </td>
                            <td>
                              <div className="rt-msg-time">
                                <div className="rt-msg-time-row">
                                  <span className="rt-msg-time-icon"><i className="fa fa-calendar-o" /></span>
                                  <span className="rt-msg-time-date">
                                    <Moment format="MMM D, YYYY">{item.callDate}</Moment>
                                  </span>
                                </div>
                                <span className="rt-msg-time-subtext">
                                  <i className="fa fa-clock-o" style={{ marginRight: "4px" }} />
                                  {moment(item.callTime?.replace(":00", ""), "hhmm").format("h:mm a")}
                                </span>
                              </div>
                            </td>
                            <td>
                              <span className="rt-call-duration-tag">
                                <i className="fa fa-hourglass-half" aria-hidden="true" /> {item.duration} Min
                              </span>
                            </td>
                            <td>
                              {item.comments ? (
                                <NotesPopover notes={item.comments} placement={key === 0 ? "bottom" : "top"} />
                              ) : (
                                <span className="wf-empty-value">No notes</span>
                              )}
                            </td>
                            <td>
                              <div className="wf-name-cell">
                                <span className="wf-name-avatar">
                                  <i className="fa fa-user" aria-hidden="true" />
                                </span>
                                <div className="wf-name-meta">
                                  <span className="wf-name-main">{item.performer || "Unknown"}</span>
                                  {item.email && <span className="wf-name-title">{item.email}</span>}
                                </div>
                              </div>
                            </td>
                            <td>
                              <div className="rt-form-buttons-row" onClick={(e) => e.stopPropagation()}>
                                {canDelete && (
                                  <button
                                    type="button"
                                    className="rt-form-action-btn is-delete"
                                    onClick={() => handleDeleteComment(item)}
                                    title="Delete"
                                    disabled={isDeleteLoading && deletingPhoneId === item.phoneId}
                                  >
                                    {isDeleteLoading && deletingPhoneId === item.phoneId ? (
                                      <i className="fa fa-spinner fa-spin" aria-hidden="true" />
                                    ) : (
                                      <i className="fa fa-trash-o" aria-hidden="true" />
                                    )}
                                  </button>
                                )}
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {/* ─── Profile Tab (Add/Edit Note) ─── */}
        {selectedKey === "profile" && (
          <div className="rt-msg-panel is-form-panel">
            <PhoneCallApplicantPopup
              handleSubmit={handleSubmit}
              selectedItem={selectedPhoneCall}
              handleEditComment={handleEditComment}
              handleCancel={() => handleSelectTab("home")}
              isLoading={isLoading}
            />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default PhoneCallApplicant;
